/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/others/my-error-state-matcher.ts.
 */
import {ErrorStateMatcher} from '@angular/material/core';
import {FormGroupDirective, NgForm, UntypedFormControl} from '@angular/forms';

/**
 * Zweck: Beschreibt class MyErrorStateMatcher und ihren Daten- oder Funktionsvertrag.
 */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isError = false;
  error_text = '';

  loading = false;

/**
 * Beschreibt Methode startLoading und ihren Rückgabevertrag.
 */
  startLoading() {
    this.loading = true;
  }

/**
 * Beschreibt Methode stopLoading und ihren Rückgabevertrag.
 */
  stopLoading() {
    this.loading = false;
  }

/**
 * Beschreibt Methode setRequired und ihren Rückgabevertrag.
 */
  setRequired() {
    this.setError('Wird benötigt!');
  }

/**
 * Beschreibt Methode setError und ihren Rückgabevertrag.
 */
  setError(text: string = null) {
    if (text) {
      this.isError = true;
      this.error_text = text;
    } else {
      this.isError = false;
      this.error_text = '';
    }
    this.stopLoading();
  }

/**
 * Beschreibt Methode setOk und ihren Rückgabevertrag.
 */
  setOk() {
    this.setError();
  }

/**
 * Beschreibt Methode isErrorState und ihren Rückgabevertrag.
 */
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return this.isError;
  }
}
